import { useState, useEffect, useContext } from "react"
import { TbArtists } from "../../components/tables/TbArtists"
import { validateArtists } from "../../helpers/validateForms"
import { ContextApp } from "../../context/ContextApp"

import Titulo from "../../components/titles/Titulo"
import InputSearch from "../../components/inputs/inputs/InputSearch"
import InputJim from "../../components/inputs/inputs/InputJim"
import SelectJim from "../../components/inputs/inputs/SelectJim"
import CheckJim from "../../components/inputs/inputs/CheckJim"
import ModalConfirm from "../../components/ModalComfirm/ModalConfirm"

import '../pageStyles.css'
import './artists.css'

const Artists = () => {

  const initialErrors = {
    nombre: '',
    imagen: ''
  }

  const { loginUp, token, refreshToken, artista, decades } = useContext(ContextApp);

  const [errors, setErrors] = useState(initialErrors);
  const [artist, setArtist] = useState(artista)
  const [file, setFile] = useState()
  const [artists, setArtists] = useState([])
  const [artistasFiltred, setArtistasFiltred] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [modoAdd, setModoAdd] = useState(true)

  useEffect(() => {
    const loadData = async () => {
      try {
        await refreshToken();
        const data = await artista.getArtists();

        setArtists(await data);
        setArtistasFiltred(await data);

      } catch (error) {
        console.log(error.message)
      }
    }
    loadData();
  }, [artista, loginUp, refreshToken])

  const filterData = (data) => {
    const newData = artists.filter((artist) => artist.ART_NOMBRE.toLowerCase().includes(data.toLowerCase()))
    setArtistasFiltred(newData)
  }
  const handleChange = (name, value) => {
    setArtist({ ...artist, [name]: value })
  }
  const handleFile = (e) => {
    setArtist({ ...artist, 'imagen': e.target.files[0].name })
    setFile(e.target.files[0])
  }

  const validateData = async(name, value) => {
    const existData = artists.filter((item) => item.ART_NOMBRE === value)
    if (existData.length > 0 && modoAdd) {
      setErrors({ ...errors, 'nombre': 'Artista ya en nuestra BBDD' })
    }
    else {
      const error = await validateArtists(name, value)
      setErrors(prevErrors =>{
        return {...prevErrors, [name]:error}
      })
    }
  }
  
  const sendForm = async () => {
    refreshToken()
    
    const postData = new FormData();
    
    await validateData('nombre', artist.nombre)
    await validateData('imagen', artist.imagen)
    
    postData.append('id', await artist.id)
    postData.append('nombre', await artist.nombre)
    postData.append('decada', await artist.decada)
    postData.append('imagen', await artist.imagen)
    postData.append('visible', await artist.visible)
    postData.append('file', file)
        
    if (artist.nombre !== '' && artist.imagen !== '') {
      modoAdd ? setArtistasFiltred(await artista.addArtist(postData, token))
        : setArtistasFiltred(await artista.updateArtist(artist, token))
      setShowForm(false);
      setArtist('');
    }
  }
  const updateArtist = (e) => {

    setArtist({
      ...artist,
      id: e.ART_CLAVE,
      nombre: e.ART_NOMBRE,
      decada: e.ART_DECADA,
      imagen: e.ART_IMAGE,
      visible: e.ART_VISIBLE.data[0]
    })
    setShowForm(true)
    setModoAdd(false)
  }
  const deleteArtist = async (e) => {
    setShowModal(!showModal)

    await refreshToken()

    const data = await artista.delArtist(artist.ART_CLAVE, token)
    setArtistasFiltred(data)
    setArtist(artista)
  }
  const showPopup = (e) => {
    setArtist(e)
    setShowModal(!showModal)
  }

  return (
    <>
      <div className="container-data">

        <section className="data-body">

          <section className="data-header">
            <Titulo>Artistas</Titulo>
            <InputSearch
              placeholder='nombre a buscar'
              onChange={filterData} />
            <button className="material-icons-outlined btn" onClick={() => setShowForm(!showForm)}>add</button>
          </section>
          {artists &&
            <section className="data-table">

              <TbArtists
                artists={artistasFiltred}
                updateArtist={updateArtist}
                deleteArtist={showPopup} />

            </section>
          }
        </section>

        <section className="data-edit">
          {showForm &&
            <section className="data-form">

              <InputJim classN='span'
                type='text'
                name='nombre'
                value={artist.nombre}
                onChange={handleChange}
                onBlur={validateData}
                placeholder='escribe nombre'
                error={errors.nombre} />
              <SelectJim
                name='decada'
                value={artist.decada}
                onChange={handleChange}
                items={decades}
                error='' />
              <CheckJim
                name='visible'
                label='Visible'
                value={artist.visible}
                onChange={handleChange}
                error='' />
              <label className="custom-file-upload span">
                <input className="typefile" type="file"
                  accept="image/png, image/jpeg"
                  multiple onChange={handleFile} />
                <label>{artist.imagen}</label>
                <i className="material-icons-outlined"> cloud_upload </i>
              </label>
              <p className="errorFile">{errors.imagen}</p>


              <button className="btn posButton" onClick={sendForm}>ENVIAR</button>
            </section>
          }
          <div className={showForm ? "data-logo hidden" : "data-logo"} />
        </section>

      </div>

      {showModal &&
        <ModalConfirm title='Confirmar eliminación' showPopup={showPopup}>
          <>
            <section className='modal-message'>
              <h2>Vas a eliminar al artista</h2>
              <h2> {artist.ART_NOMBRE} </h2>
            </section>
            <section className='modal-buttons'>
              <button onClick={deleteArtist}>ACEPTAR</button>
              <button onClick={showPopup}>CANCELAR</button>
            </section>
          </>
        </ModalConfirm>
      }
    </>
  )
}
export default Artists
